import { MaterialType } from '../../../constants/MaterialModels';

export const isMeteredWater = (materialId, materialStore) => {
  return !!materialStore.materialsWithDetails
    ?.find(v => v.itemId === Number(materialId)
      && v.assignment === MaterialType.Metered
      && isWaterOrSecondWater(v.itemId, materialStore)
    );
};

export const isWeighedWater = (materialId, materialStore) => {
  return !!materialStore.materialsWithDetails
    ?.find(v => v.itemId === Number(materialId)
      && v.assignment === MaterialType.Weighed
      && isWaterOrSecondWater(v.itemId, materialStore)
    );
};

export const isWaterOrSecondWater = (materialId, materialStore) => {
  return materialStore.isWater(materialId) || materialStore.isSecondWater(materialId);
};
